import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  yes: () => __(translations.yesNoPicker.yes, 'Yes'),
  no: () => __(translations.yesNoPicker.no, 'No'),
};
